import React, { Component } from 'react';
import DeviceInfo from 'Components/UsersView/deviceInfo';
import NewDevice from 'Components/UsersView/newDevice';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import Popup from 'Components/Common/popup';
import SettingsButton from 'Components/UsersView/settingsButton';
import TransparentLoadIndicator from "Components/Common/transparentLoadIndicator";
import { SynchronizingStatus, SynchronizingTask, ShowAlert } from "Utils/CommonFunctions";
import UsersStore from 'Stores/usersStore';
import AppStore from 'Stores/AppStore';
import IconsContainer from 'Utils/IconsContainer';

/**
 * @typedef {object} props
 * @property {WebUser} user
 * @extends {Component<props>}
 */
class UserLine extends Component {

    /** @param {props} props */
    constructor(props) {
        super(props);
    }

    userLineInfo() {
        return UsersStore.usersLinesInfos.Get(this.props.userLid);
    }

    handleDeviceButtonClick(e) {
        this.userLineInfo().closed = this.userLineInfo().closed == false;
        this.forceUpdate();
    }

    GetBlockIcons() {
        let user = this.props.user;

        let userState = user.state;

        return UsersStore.BlockReasons(false).map(reason => (
            <Popup className={`block-icon ${userState.blockedReasons[reason.name] == true ? ' show' : ''} ${this.userLineInfo().topPopup ? 'top-popup' : ''} block-reason-icon-${reason.name}`}
                popupText={reason.description}
                key={`${user.id}_${reason.name}`}>
                {IconsContainer.Get(reason.icon)}
            </Popup>
        ));
    }

    GetButtonsForLine() {
        let user = this.props.user;
        let userState = user.state;
        let userLineInfo = this.userLineInfo();

        let isMeeting = AppStore.isMeeting;

        let isUserLogicallyRemoveInProcess =
            // логическое удаление пользователя или удаление ДЛ . в процессе
            (
                userState.task === SynchronizingTask.removingUser
                ||
                userState.task === SynchronizingTask.removingUserDl
            )
            &&
            userState.status === SynchronizingStatus.inProgress
            ;

        let isCanRemoveLogically =
            isMeeting
                ? userState.meetingCanRemoveLogically
                : userState.docCanRemoveLogically;
        let isCanRemovePhysically = userState.canRemovePhysically;
        let isUserPhysicallyRemoveInProcess =
            userState.task == SynchronizingTask.removingUserPhysically
            &&
            userState.status == SynchronizingStatus.inProgress
            ;

        let removeUserButtonVisible = userState.inProgress == false && userLineInfo.closed == false;
        let removeUserIndicatorVisible = isUserLogicallyRemoveInProcess;
        let removePhysicallyButtonVisible =
            // логическое удаление пользователя . завершено . можно удалить физически
            isCanRemovePhysically == true
            &&
            isUserLogicallyRemoveInProcess == false
            ;
        let deviceAndSettingsButtonVisible =
            isCanRemovePhysically == false
            &&
            removeUserIndicatorVisible == false
            ;

        let devicesText = 'Устройства';
        let devicesButtonClass = '';

        if (isCanRemovePhysically == true) {
            this.userLineInfo().closed = true;
        }

        if (this.userLineInfo().closed == false) {
            devicesText = 'Скрыть';
            devicesButtonClass = 'blue-button'
        }

        let blockSettingsButton = AppStore.isMeeting
            ? userState.meetingBlockSettingsButton
            : userState.docBlockSettingsButton;
        let classForSettingsButton = blockSettingsButton ? 'disabled' : '';

        return (
            <div className="line-buttons">
                {
                    removeUserButtonVisible
                        ? (
                            <button className={"remove-user-button red-button" + (isCanRemoveLogically ? '' : ' disabled')}
                                onClick={_ => UsersStore.ShowRemoveUserModal(user, false)}>
                                Удалить пользователя
                            </button>)
                        : ""

                }
                <div className="manage-user-buttons">
                    {
                        removeUserIndicatorVisible
                            ? (
                                <TransparentLoadIndicator className='remove-user-indicator'
                                    processInfo={{
                                        progress: (
                                            userState.documentsLoadProgressFull.total == 0
                                                ? 0
                                                : Math.floor(userState.documentsLoadProgressFull.loaded / userState.documentsLoadProgressFull.total * 100)
                                        )
                                    }}
                                    text={(`${(userState.task === SynchronizingTask.removingUserDl
                                        ? "ДЛ в процессе удаления"
                                        : "Пользователь в процессе удаления")} -`)}
                                    withoutIndicator={true} />
                            )
                            : ""
                    }
                    {
                        removePhysicallyButtonVisible
                            ? (
                                <button className={"red-button remove-physically-button " + (isUserPhysicallyRemoveInProcess ? "disabled" : "")}
                                    onClick={_ => UsersStore.ShowRemoveUserModal(user, true)}>
                                    Удалить физически
                                </button>
                            )
                            : ""
                    }
                    {
                        deviceAndSettingsButtonVisible
                            ? (
                                <button className={`${devicesButtonClass} ${classForSettingsButton}`}
                                    onClick={this.handleDeviceButtonClick.bind(this)}>{devicesText}</button>
                            )
                            : ""
                    }
                    {
                        deviceAndSettingsButtonVisible
                            ? (
                                <Link to={`${window.SmrLocation}/userSettings?userId=${user.id}`}
                                    className={classForSettingsButton} >
                                    <SettingsButton processInfo={userState} />
                                </Link>
                            )
                            : ""
                    }
                </div>
            </div>
        );
    }

    GetNormalLine() {
        let user = this.props.user;

        let userState = user.state;

        let deviceLine = this.userLineInfo().closed ? null : (
            <div className="users-devices">
                {user.devices.map(device => (
                    <DeviceInfo
                        key={`${user.lid}_${device.code}`}
                        user={user}
                        device={device}
                    />
                ))}
                <NewDevice user={this.props.user} />
            </div>
        );
        let notActive = AppStore.isMeeting
            ? userState?.blockedReasons?.meetingNotActive
            : userState?.blockedReasons?.docNotActive;

        let className = '';

        if (userState.inProgress === true && userState.task === SynchronizingTask.removingUser)
            className = 'removing';
        else if (userState.status === SynchronizingStatus.inProgress) {
            className = 'synchronizing';
        }

        return (
            <div className={"user-line smr-table-line " + className}
                id={`user-line-${this.props.userLid}`}>
                <div className="users-information">
                    <div className={"user-not-active-block-icon-container" + (notActive ? ' show' : '')}>
                        <Popup popupText="Пользователь не активирован"
                            className={(this.userLineInfo().topPopup ? 'top-popup' : '')}>
                            <div className={"user-not-active-block-icon " + (notActive ? ' show' : '')} />
                        </Popup>
                    </div>
                    <Popup popupText={user.userName}
                        className={`user-name ${this.userLineInfo().topPopup ? 'top-popup' : ''}`}>
                        <span>{user.userName}</span>
                    </Popup>
                    <div className="blocked-icons">
                        {this.GetBlockIcons()}
                    </div>
                    {this.GetButtonsForLine()}
                </div>
                {deviceLine}
            </div>
        );
    }

    render() {
        let line = this.GetNormalLine();

        return line;
    }
}

export default observer(UserLine);